import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Skip if user passed from AuthCallback
    if (location.state?.user) return;
    
    // Only redirect after loading is complete and user is not authenticated
    if (!loading && user === false) {
      navigate('/login', { replace: true });
    }
  }, [user, loading, navigate, location.state]);

  // Show loading state
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-[#007AFF] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-gray-500 text-sm uppercase tracking-wider">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (user === false) {
    return null;
  }

  return children;
}
